<template>
  <div class="card">
    <h2 class="title">承保保险公司选择</h2>
    <div class="content">
      <a-radio-group v-model="form.comp" @change="selectCompany">
        <a-radio v-for="item in companyCode" :key="item.code" :value="item.code">{{item.name}}</a-radio>
      </a-radio-group>
      <div class="btns">
        <a-button type="primary" @click="downloadMGUPros">生成试算报价书</a-button>
        <a-button type="primary" @click="goInsured" v-if="step === 1">直接投保</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { companyCode } from "../js/data";

export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    step: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      companyCode, // 公司码表
      form: {
        companyname: "",
        comp: "0"
      }
    }
  },
  mounted() {
    this.form.comp = this.baseInfo.comp || "0"
    this.selectCompany();
  },
  methods: {
    // 选择公司
    selectCompany() {
      for(let i = 0; i < this.companyCode.length; i ++) {
        if(this.companyCode[i].code === this.form.comp) {
          this.form.companyname = this.companyCode[i].fullName;
          break;
        }
      }
      this.$emit("setInfo", this.form);
    },
    // 直接投保
    goInsured() {
      this.$emit("goInsured")
    },
    // 生成试算报价书
    downloadMGUPros() {
      this.$emit("downloadMGUPros")
    }
  }

}
</script>

<style lang="scss" scoped>
.content{
  padding: 20px;
  font-size: 20px;
}
</style>